// LOT 46 v2 · 3.14 · le séparateur « · » n'ouvre jamais une ligne : il reste collé au mot d'avant (espace insécable)
const corrige = (n) => {
  if (n.nodeType === 3) { if (n.nodeValue.includes(' · ')) n.nodeValue = n.nodeValue.replace(/ · /g, '\u00a0· '); return; }
  if (n.nodeType !== 1 || /^(SCRIPT|STYLE|TEXTAREA|INPUT)$/.test(n.nodeName)) return;
  const w = document.createTreeWalker(n, NodeFilter.SHOW_TEXT);
  for (let t = w.nextNode(); t; t = w.nextNode()) if (t.nodeValue.includes(' · ') && !(t.parentNode && t.parentNode.closest && t.parentNode.closest('textarea,[contenteditable="true"]'))) t.nodeValue = t.nodeValue.replace(/ · /g, '\u00a0· ');
};
export const garderSeparateurs = () => {
  if (typeof MutationObserver === 'undefined') return;
  new MutationObserver((ms) => ms.forEach((m) => (m.type === 'characterData' ? corrige(m.target) : m.addedNodes.forEach(corrige)))).observe(document.body, { childList: true, subtree: true, characterData: true });
};
